// FE-SCRM-052 — display labels for the Opportunities list view.
//
// The reports tab already exports a STAGE_LABEL / LOST_REASON_LABEL
// shared with the loss-analysis chart; we re-export those here so a
// future tweak ripples through both surfaces. Type / band / cadence
// / confidence labels live alongside because they're list-specific.

export { STAGE_LABEL, LOST_REASON_LABEL } from "@/features/sales/reports/labels";

import type {
  CadenceHealth, LivesBand, RenewalConfidence,
} from "./types";


export const TYPE_LABEL: Record<string, string> = {
  new_business: "New business",
  bor_takeover: "BOR takeover",
  rfp_response: "RFP response",
  expansion: "Expansion",
};


export const LIVES_BAND_LABEL: Record<LivesBand | string, string> = {
  micro: "Micro (< 10)",
  small: "Small (10-50)",
  mid_market: "Mid-market (51-500)",
  large: "Large (501-2500)",
  enterprise: "Enterprise (2500+)",
};


export const CADENCE_HEALTH_LABEL: Record<CadenceHealth | string, string> = {
  ahead: "Ahead",
  on_track: "On track",
  behind: "Behind",
  critical: "Critical",
  not_yet_urgent: "Not yet urgent",
};


export const RENEWAL_CONFIDENCE_LABEL: Record<RenewalConfidence | string, string> = {
  confirmed: "Confirmed",
  inferred_from_form5500: "Inferred (Form 5500)",
  producer_estimate: "Producer estimate",
  unknown: "Unknown",
};


const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];


export function formatRenewal(
  month: number | null, year: number | null,
): string {
  if (month === null || year === null) return "—";
  const name = MONTH_NAMES[month - 1] ?? String(month);
  return `${name} ${year}`;
}


export function formatRelativeDate(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", {
    month: "short", day: "numeric", year: "numeric",
  });
}


export function formatPercent(p: number | null): string {
  if (p === null || p === undefined) return "—";
  return `${p}%`;
}
